import type { Account } from "./index.js";

export function getAccountBalance(account: Account): {
  balance: number | undefined;
  currency: string | undefined;
} {
  switch (account.accountType) {
    case "bridge":
    case "gcl":
    case "powens":
      return { balance: account.balance, currency: account.currency };
    case "swan":
      return {
        balance: account.swan_account?.balances
          ? parseFloat(account.swan_account.balances.booked.value)
          : undefined,
        currency: account.swan_account?.currency,
      };
    case "treezor":
      return {
        balance: account.treezorWallet?.solde,
        currency: account.treezorWallet?.currency,
      };
  }
}
